import React from "react";
import { useNavigate } from "react-router-dom";

const SessionTimeout: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Oops! Session Timeout</h1>
        <p className="text-gray-700 mb-6">
          Your session has expired due to inactivity or token expiration. Please log in again to continue.
        </p>
        <button
          onClick={handleLoginRedirect}
          className="px-6 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors"
        >
          Go Back 
        </button>
      </div>
    </div>
  );
};

export default SessionTimeout;
